//SprintCentralWBSF
import React, { useEffect, useState } from 'react'
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFetch from '../../hooks/useFetch';

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip, faMicrophone, faSliders } from '@fortawesome/free-solid-svg-icons';
import './styles/SprintCentral.css';
import AreaChart from './AreaChart';
import AILightComponent from '../../components/AILightComponent';
import SpeechInputComponent from '../../components/SpeechInputComponent';
import { Generate3PTaskCode } from '../../components/GenerateThink5whysCode';
import QRCode from 'react-qr-code';
import adimage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import adimage2 from '../../assets/navlogo.png';
import { logout } from "../../redux/actions/authActions";

const WBSForm = () => {
  const authState = useSelector(state => state.authReducer);
  const isLoggedIn = authState?.isLoggedIn || false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [fetchData, { loading }] = useFetch();
  const [userName, setUserName] = useState(authState.user.name);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
   };

  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);

  const [wbsName, setWBSName] = useState('');
  const [p, setP] = useState('');
  const [o, setO] = useState('');
  const [m, setM] = useState('');
  const [e, setE] = useState('');
  const [sd, setSD] = useState('');

  const [addlDetails, setAddlDetails] = useState(false);
  const [tDesc, setTDesc] = useState('');
  const [unit, setUnit] = useState('Hrs');
  const [autoWBSCode, setautoWBSCode] = useState('');

  useEffect(() => {
    setautoWBSCode(Generate3PTaskCode());
  }, []);

  const [isRefTask, setIsRefTask] = useState(false);
  const [refTaskCode, setRefTaskCode] = useState('');
  const [MWBSCode, setMWBSCode] = useState('');
  const [WBSGroup, setWBSGroup] = useState('');
  const [wbsProject, setWBSProject] = useState('');
  const [wbsProgram, setWBSProgram] = useState('');
  const [entityName, setEntityName] = useState('');
  const [wbsDepartment, setWBSDepartment] = useState('');
  // const [jobID, setJobID] = useState('');
  // const [cost, setCost] = useState(0);
  const [currency, setCurrency] = useState('₹');
  // const [pDetails, setPDetails] = useState('');
  // const [oDetails, setODetails] = useState('');
  const [mDetails, setMDetails] = useState('');
  const [remarks, setRemarks] = useState('');
  const [showCard, setShowCard] = useState(false);
  const [showPDetails, setShowPDetails] = useState(false);
  const [showODetails, setShowODetails] = useState(false);
  const [showMDetails, setShowMDetails] = useState(false);
  const [showMicroWBS, setShowMicroWBS] = useState(false);
  const [showAd, setShowAd] = useState(true);
  const [microWBS, setMicroWBS] = useState([]);
  const [taskWBS, setTaskWBS] = useState("");
  const [estTimeWBS, setEstTimeWBS] = useState("");
  const [costWBS, setCostWBS] = useState("");
  const [oValWBS, setOValWBS] = useState(false);
  const [mValWBS, setMValWBS] = useState(false);
  const [pValWBS, setPValWBS] = useState(false);
  const [predecessorWBS, setPredecessorWBS] = useState([]); 
  const [oTimeWBS, setOTimeWBS] = useState("");
  const [mTimeWBS, setMTimeWBS] = useState("");
  const [pTimeWBS, setPTimeWBS] = useState("");
  const [oCostWBS, setOCostWBS] = useState("");
  const [mCostWBS, setMCostWBS] = useState("");
  const [pCostWBS, setPCostWBS] = useState("");

  const [remarksWBS, setRemarksWBS] = useState("");
  const [editIndexWBS, setEditIndexWBS] = useState(null);

  const addRecordWBS = () => {
    if (!taskWBS.trim()) {
      alert("Task name is required");
      return;
    }

    if (oValWBS && (isNaN(parseFloat(oTimeWBS)) || isNaN(parseFloat(oCostWBS)))) {
      alert("Please enter valid Optimistic time and cost");
      return;
    }
    if (mValWBS && (isNaN(parseFloat(mTimeWBS)) || isNaN(parseFloat(mCostWBS)))) {
      alert("Please enter valid Most Likely time and cost");
      return;
    }
    if (pValWBS && (isNaN(parseFloat(pTimeWBS)) || isNaN(parseFloat(pCostWBS)))) {
      alert("Please enter valid Pessimistic time and cost");
      return;
    }

    const newRecordWBS = {
      task: taskWBS,
      predecessor: [...predecessorWBS],
      oVal: oValWBS,
      mVal: mValWBS,
      pVal: pValWBS,
      oTime: parseFloat(oTimeWBS) || 0,
      mTime: parseFloat(mTimeWBS) || 0,
      pTime: parseFloat(pTimeWBS) || 0,
      oCost: parseFloat(oCostWBS) || 0,
      mCost: parseFloat(mCostWBS) || 0,
      pCost: parseFloat(pCostWBS) || 0,
      remarks: remarksWBS,
      ev: 0, // placeholder, will be calculated later
    };

    if (editIndexWBS !== null) {
      const updated = [...microWBS];
      updated[editIndexWBS] = newRecordWBS;
      setMicroWBS(updated);
      setEditIndexWBS(null);
    } else {
      setMicroWBS([...microWBS, newRecordWBS]);
    }

    setTaskWBS("");
    setPredecessorWBS([]);
    setOValWBS(false);
    setMValWBS(false);
    setPValWBS(false);
    setOTimeWBS("");
    setMTimeWBS("");
    setPTimeWBS("");
    setOCostWBS("");
    setMCostWBS("");
    setPCostWBS("");
    setRemarksWBS("");
  };

  const editRecordWBS = (index) => {
    const r = microWBS[index];
    setTaskWBS(r.task);
    setPredecessorWBS([...r.predecessor]);
    setOValWBS(r.oVal);
    setMValWBS(r.mVal);
    setPValWBS(r.pVal);
    setOTimeWBS(r.oTime.toString());
    setMTimeWBS(r.mTime.toString());
    setPTimeWBS(r.pTime.toString());
    setOCostWBS(r.oCost.toString());
    setMCostWBS(r.mCost.toString());
    setPCostWBS(r.pCost.toString());
    setRemarksWBS(r.remarks);
    setEditIndexWBS(index);
  };

  const deleteRecordWBS = (index) => {
    setMicroWBS(prev => prev.filter((_, i) => i !== index));
    if (editIndexWBS === index) {
      setEditIndexWBS(null);
    }
  };

  const populateFromMicroWBS = () => {
    let sumO = 0;
    let sumM = 0;
    let sumP = 0;

    microWBS.forEach((r) => {
      if (r.oVal) sumO += parseFloat(r.oTime) || 0;
      if (r.mVal) sumM += parseFloat(r.mTime) || 0;
      if (r.pVal) sumP += parseFloat(r.pTime) || 0;
    });

    setO(sumO);
    setM(sumM);
    setP(sumP);
  };

  const [showPERTTable, setShowPERTTable] = useState(false);
  const [showPERTCard, setShowPERTCard] = useState(false);
  const [pertData, setPERTData] = useState([]); 

  const generatePERTData = () => {
    const data = microWBS.map((r, index) => {
      const oTime = r.oVal ? parseFloat(r.oTime || 0) : 0;
      const mTime = r.mVal ? parseFloat(r.mTime || 0) : 0;
      const pTime = r.pVal ? parseFloat(r.pTime || 0) : 0;
      const ev = (oTime + 4 * mTime + pTime) / 6;
      return {
        node: index + 1,
        task: r.task,
        predecessor: r.predecessor || [],
        oVal: oTime,
        mVal: mTime,
        pVal: pTime,
        ev: ev.toFixed(2),
        cost: r.cost
      };
    });

    setPERTData(data);
  };

  const [showCriticalPath, setShowCriticalPath] = useState(false);
  const [criticalPath, setCriticalPath] = useState([]); 

  const generateCriticalPath = () => {
    if (pertData.length === 0) return;

    const nodeMap = {};
    pertData.forEach(r => {
      nodeMap[r.task] = {...r};
    });

    const earliestFinish = {};
    const calcEF = (task) => {
      const node = nodeMap[task];
      if (!node) return 0;
      if (earliestFinish[task] !== undefined) return earliestFinish[task];

      const maxPredEF = node.predecessor.length > 0
        ? Math.max(...node.predecessor.map(pred => calcEF(pred)))
        : 0;

      const ef = maxPredEF + node.ev;
      earliestFinish[task] = ef;
      return ef;
    };

    const projectDuration = Math.max(...pertData.map(r => calcEF(r.task)));

    const path = [];
    const findPath = (task) => {
      const node = nodeMap[task];
      const maxPredEF = node.predecessor.length > 0
        ? Math.max(...node.predecessor.map(pred => earliestFinish[pred]))
        : 0;

      const ef = maxPredEF + node.ev;
      if (Math.abs(ef - projectDuration) < 0.01) {
        path.unshift(node); // prepend to path
        if (node.predecessor.length > 0) {
          // find predecessor that contributed max EF
          const predTask = node.predecessor.reduce((maxPred, curr) =>
            earliestFinish[curr] > earliestFinish[maxPred] ? curr : maxPred
          );
          findPath(predTask);
        }
      }
    };
    const lastNode = pertData.reduce((maxNode, n) => 
      earliestFinish[n.task] > earliestFinish[maxNode.task] ? n : maxNode
    );
    findPath(lastNode.task);

    setCriticalPath(path);
    setShowCriticalPath(true);
  };

  const [PERTChartNodes, setPERTChartNodes] = useState([]);
  const [PERTChartEdges, setPERTChartEdges] = useState([]);
  const [showPERTChart, setShowPERTChart] = useState(false);

  const generatePERTChart = () => {
    if (pertData.length === 0) return;
    const chartNodes = pertData.map((node, i) => ({
      ...node,
      x: 50 + (i % 4) * 180, // 4 nodes per row
      y: 50 + Math.floor(i / 4) * 120
    }));
    const chartEdges = [];
    chartNodes.forEach(node => {
      node.predecessor.forEach(pred => {
        const predNode = chartNodes.find(n => n.task === pred);
        if (predNode) {
          chartEdges.push({
            from: { x: predNode.x, y: predNode.y },
            to: { x: node.x, y: node.y }
          });
        }
      });
    });

    setPERTChartNodes(chartNodes);
    setPERTChartEdges(chartEdges);
    setShowPERTChart(true);
  };

  // const [showDetails, setShowDetails] = useState(true);
  const [isSaved, setIsSaved] = useState(false);
  const [emethod, setEmethod] = useState(true);  // False. Triangular Distribution (Simple Average), True. PERT Estimate (Weighted)

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (name === "pDetails") {
    //   setPDetails(value);
    // } if (name === "oDetails") {
    //   setODetails(value);
    // } else 
    if (name === "mDetails") {
      setMDetails(value);
    } else if (name === "remarks") {
      setRemarks(value);
    }
  };

  const calculate = () => {
    const pessimistic = parseFloat(p);
    const optimistic = parseFloat(o);
    const mostLikely = parseFloat(m);
    if (isNaN(pessimistic) || isNaN(optimistic) || isNaN(mostLikely)) {
      alert("Please enter valid numbers for O, M, and P.");
      return;
    }
    let estimated;
    if (emethod) {
      estimated = (optimistic + 4 * mostLikely + pessimistic) / 6;
    } else {
      estimated = (optimistic + mostLikely + pessimistic) / 3;
    }
    const standardDeviation = (pessimistic - optimistic) / 6;
    setE(estimated.toFixed(2));
    setSD(standardDeviation.toFixed(2));
  };

  const validateNumberInput = (value) => {
    return /^\d+(\.\d+)?$/.test(value); // allows integers and decimals
  };

  const validateInputs = () => {
    if (!p || !validateNumberInput(p)) {
      alert("Pessimistic (P) should contain a valid number.");
      return false;
    }

    if (!o || !validateNumberInput(o)) {
      alert("Optimistic (O) should contain a valid number.");
      return false;
    }

    if (!m || !validateNumberInput(m)) {
      alert("Most Likely (M) should contain a valid number.");
      return false;
    }

    return true;
  };

  const saveWBS = () => {
    setIsSaved(true);
  };

  const downloadPDF = async () => {
    const element = document.getElementById("estimationCard");

    if (!element) {
      alert("Estimation card not found.");
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: "#ffffff"
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 15;

    const imgWidth = pageWidth - margin * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let position = margin;

    /* Header */
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(16);
    pdf.text(
      "Think5Whys WBS-PTM",
      pageWidth / 2,
      12,
      { align: "center" }
    );

    pdf.setFontSize(11);
    pdf.setFont("helvetica", "normal");
    pdf.text(
      "Three Point Estimation Report",
      pageWidth / 2,
      18,
      { align: "center" }
    );

    pdf.setDrawColor(200);
    pdf.line(margin, 22, pageWidth - margin, 22);

    position = 28;

    /* Add captured UI */
    if (imgHeight < pageHeight - 40) {
      pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
    } else {
      let heightLeft = imgHeight;
      let y = position;

      pdf.addImage(imgData, "PNG", margin, y, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        pdf.addPage();
        y = 15;
        pdf.addImage(imgData, "PNG", margin, y - imgHeight + heightLeft, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
    }

    /* Footer */
    const today = new Date().toLocaleString();

    pdf.setFontSize(9);
    pdf.setTextColor(120);

    pdf.text(
      `Generated by Think5Whys Estimation Lab`,
      margin,
      pageHeight - 10
    );

    pdf.text(
      `Generated on: ${today}`,
      pageWidth - margin,
      pageHeight - 10,
      { align: "right" }
    );

    pdf.save(`Think5Whys-WBS-PERT-${autoWBSCode}.pdf`);
  };

  return (
    <div className='bg-black text-white [&_p]:text-white'>
      <div className="min-h-screen bg-black p-2 text-sm">
        <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
            <div className='flex flex-col'>
                <h2 className="text-lg lg:text-xl font-semibold text-yellow-200"> 
                    <FontAwesomeIcon icon={faSliders} className="mr-2 text-yellow-500" />
                    Think5Whys WBS-PERT
                </h2>
                <h2 className="text-sm lg:text-lg text-gray-200">Work Breakdown Structure. Project Evaluation & Review Technoque.</h2>
                {/* <h2 className="text-xs lg:text-sm text-gray-400 mb-2">A Magical tool for Students, Teachers, Professionals, MSME Onwers, Workers, Children, Family, Government, Business</h2> */}
            </div>
            <div className="hidden md:flex items-center gap-3">
                {isLoggedIn ? (
                    <>
                    <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
                    <button
                        onClick={handleLogout}
                        className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                        title="Logout"
                    >
                        ⏻
                    </button>
                    </>
                ) : (
                    <>
                        <button
                            onClick={() => navigate("/login")}
                            className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
                        >
                            🔐 
                        </button>
                    </>
                )}
            </div>
            <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
            aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? "×" : "☰"}
            </button>
        </header>

        {isMobileMenuOpen && (
            <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
            {isLoggedIn ? (
                <div className="flex flex-col items-center gap-3">
                <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                    <div className="flex gap-3">
                    <button
                        onClick={handleLogout}
                        className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                    >
                        ⏻
                    </button>
                    </div>
                </div>
            ) : (
                <div className="flex justify-center gap-6">
                <Link to="/login" className="text-teal-300">🔐</Link>
                </div>
            )}
            </div>
        )}
        { showAd && (
        <div
            className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
            onClick={() => navigate("/roomanywhere")}
        >
            <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
            <img
                src={adimage1} 
                alt="Ad"
                className="w-full h-full object-cover"
            />
            </div>
            <div className="flex flex-col text-left">
            <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
            <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
            <p className="text-sm mt-1">Click to see more!</p>
            </div>
        </div>
        )}                

        <div className='mt-2 border border-cyan-300 bg-black rounded-sm text-white p-4'>
            <div className="flex items-center flex-row bg-black shadow-md rounded-lg mb-2">
                <p className="text-gray-100 text-m font-semibold mr-4">WBS Code: {autoWBSCode}</p>
                <div className='border border-white p-2'><QRCode value={autoWBSCode} size={64}/></div>
            </div>              
            <div className="flex flex-col">
            <label className="text-white text-xs lg:text-sm font-medium mb-2">WBS Title / Name:</label>
            <input
                className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                type="text"
                value={wbsName}
                onChange={(e) => setWBSName(e.target.value)}
            />
            </div>
            <div className='flex flex-row mt-4'>
            <input 
                type="checkbox" 
                className="mr-2 cursor-pointer"
                checked={isRefTask} 
                onChange={() => setIsRefTask(!isRefTask)} 
            />
            <span className="text-xs lg:text-sm text-gray-100">Populate from previous WBS recrod</span>
            </div>
            { isRefTask && (
            <div className="flex flex-col bg-cyan-600 p-2 shadow-md rounded-lg mb-2 mt-2">
                <label className="text-yellow-200 text-xs lg:text-sm font-medium mb-2">Populate from previous WBS recrod</label>
                
                <label className="text-white text-xs lg:text-sm font-medium mb-2">Input Reference WBS Title / Name:</label>
                <input
                className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                type="text"
                value={refTaskCode}
                onChange={(e) => setRefTaskCode(e.target.value)}
                />                               
                <button
                className="mt-2 px-3 text-xs lg:text-sm lg:w-40 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-500 transition"
                onClick={() => {
                    clone3PData();
                }}
                disabled={true} 
                >
                Populate Now
                </button>   
            </div>   
            )}                

            <div className="flex flex-row mt-2 mb-2 bg-gray-700 p-4">          
            <div className='flex flex-row'>
                <input 
                type="checkbox" 
                className="mr-2 cursor-pointer"
                checked={isCheckedAISupport} 
                onChange={() => setIsCheckedAISupport(!isCheckedAISupport)} 
                />
                <span className="text-xs lg:text-sm text-gray-100">Gen AI Support</span>
                <FontAwesomeIcon icon={faMicrochip} className="text-yellow-500 text-xl ml-3" />
            </div>
            <div className='flex flex-row ml-16'>
                <input 
                type="checkbox" 
                className="mr-2 cursor-pointer"
                checked={showMicrophoneAlert} 
                onChange={() => setShowMicrophoneAlert(!showMicrophoneAlert)} 
                />
                <span className="text-xs lg:text-sm text-gray-100">Enable Voice Input</span>
                <FontAwesomeIcon icon={faMicrophone} className="text-yellow-500 text-xl ml-3" />
            </div>
            </div>   

            {/* <div className='border border-rose-300 p-4 rounded-sm'> */}
            <div className="flex flex-col mb-2">
                <label className="text-white text-xs lg:text-sm font-medium mb-2">Estimation Unit:</label>
                <select
                className="w-32 h-10 text-black text-xs lg:text-sm border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={unit}
                onChange={(e) => setUnit(e.target.value)}
                >
                <option value="Hrs">Hours</option>
                <option value="Days">Days</option>
                <option value="Weeks">Weeks</option>
                <option value="Months">Months</option>
                <option value="Minutes">Minutes</option>
                </select>
            </div>   
            
            <div className="bg-gray-900 p-3 rounded-lg border border-teal-400 space-y-3">
              <h2 className='text-yellow-200 py-2 text-sm lg:text-lg'>
                  Building Micro WBS (Work Breakdown Structure) for the Task
              </h2>

              <div className="flex flex-col space-y-2">
                  <input
                  className="text-black p-2 rounded"
                  placeholder="Task Name *"
                  value={taskWBS}
                  onChange={(e) => setTaskWBS(e.target.value)}
                  />
                  <label className="text-white text-xs">Select Predecessors (if any):</label>
                  <select
                  className="text-black p-2 rounded"
                  multiple
                  value={predecessorWBS}
                  onChange={(e) =>
                      setPredecessorWBS(Array.from(e.target.selectedOptions, option => option.value))
                  }
                  >
                  {microWBS.map((r, i) => (
                      <option key={i} value={r.task}>{r.task}</option>
                  ))}
                  </select>
                  <div className="grid grid-cols-2 gap-2">
                  <div className="space-y-1">
                      <p className="text-white text-xs font-semibold">Optimistic (O)</p>
                      <input
                      type="number"
                      placeholder={`Time (${unit})`}
                      value={oTimeWBS}
                      onChange={(e) => setOTimeWBS(e.target.value)}
                      className="text-black p-2 rounded w-full"
                      />
                      <input
                      type="number"
                      placeholder={`Cost (${currency})`}
                      value={oCostWBS}
                      onChange={(e) => setOCostWBS(e.target.value)}
                      className="text-black p-2 rounded w-full"
                      />
                      {/* <label className="text-white flex items-center space-x-1">
                      <input
                          type="checkbox"
                          checked={oValWBS}
                          onChange={() => setOValWBS(!oValWBS)}
                      />
                      <span>Consider O</span>
                      </label> */}
                  </div>

                  <div className="space-y-1">
                      <p className="text-white text-xs font-semibold">Most Likely (M)</p>
                      <input
                      type="number"
                      placeholder={`Time (${unit})`}
                      value={mTimeWBS}
                      onChange={(e) => setMTimeWBS(e.target.value)}
                      className="text-black p-2 rounded w-full"
                      />
                      <input
                      type="number"
                      placeholder={`Cost (${currency})`}
                      value={mCostWBS}
                      onChange={(e) => setMCostWBS(e.target.value)}
                      className="text-black p-2 rounded w-full"
                      />
                      {/* <label className="text-white flex items-center space-x-1">
                      <input
                          type="checkbox"
                          checked={mValWBS}
                          onChange={() => setMValWBS(!mValWBS)}
                      />
                      <span>Consider M</span>
                      </label> */}
                  </div>

                  <div className="space-y-1">
                      <p className="text-white text-xs font-semibold">Pessimistic (P)</p>
                      <input
                      type="number"
                      placeholder={`Time (${unit})`}
                      value={pTimeWBS}
                      onChange={(e) => setPTimeWBS(e.target.value)}
                      className="text-black p-2 rounded w-full"
                      />
                      <input
                      type="number"
                      placeholder={`Cost (${currency})`}
                      value={pCostWBS}
                      onChange={(e) => setPCostWBS(e.target.value)}
                      className="text-black p-2 rounded w-full"
                      />
                      {/* <label className="text-white flex items-center space-x-1">
                      <input
                          type="checkbox"
                          checked={pValWBS}
                          onChange={() => setPValWBS(!pValWBS)}
                      />
                      <span>Consider P</span>
                      </label> */}
                  </div>
                </div>
                <input
                className="text-black p-2 rounded"
                placeholder="Remarks"
                value={remarksWBS}
                onChange={(e)=>setRemarksWBS(e.target.value)}
                />
                <button
                className="w-40 bg-green-600 text-white px-3 py-1 rounded"
                onClick={addRecordWBS}
                >
                {editIndexWBS !== null ? "Update Task" : "Add Task"}
                </button>
            </div>

            <div className="space-y-3 mt-4">
                {microWBS.map((r, i) => (
                  <div
                      key={i}
                      className="bg-gray-800 p-3 rounded-lg border border-gray-700"
                  >
                    <div className="flex justify-between items-center mb-2">
                      <p className="text-yellow-300 font-semibold">SN {i + 1}</p>
                      <div className="space-x-2">
                          <button
                          className="bg-yellow-500 text-black px-2 py-1 w-16 rounded text-xs"
                          onClick={() => editRecordWBS(i)}
                          >
                          Edit
                          </button>
                          <button
                          className="bg-red-600 px-2 py-1 w-16 rounded text-xs"
                          onClick={() => deleteRecordWBS(i)}
                          >
                          Delete
                          </button>
                      </div>
                    </div>

                    <div className="mb-2">
                      <p className="text-gray-400 text-xs">Task</p>
                      <p className="text-white">{r.task}</p>
                    </div>
                    {r.predecessor.length > 0 && (
                    <div className="mb-2">
                        <p className="text-gray-400 text-xs">Predecessors</p>
                        <p className="text-white">{r.predecessor.join(", ")}</p>
                    </div>
                    )}
                    <div className="grid grid-cols-2 gap-2 mb-2">
                      <div>
                          <p className="text-gray-400 text-xs">Time (O/M/P)</p>
                          <p>{`${r.oTime}/${r.mTime}/${r.pTime} ${unit}`}</p>
                      </div>
                      <div>
                          <p className="text-gray-400 text-xs">Cost (O/M/P)</p>
                          <p>{`${r.oCost}/${r.mCost}/${r.pCost} ${currency}`}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-2 mb-2">
                      <div>
                          <p className="text-gray-400 text-xs">O</p>
                          <p>{r.oVal ? "✔" : "-"}</p>
                      </div>
                      <div>
                          <p className="text-gray-400 text-xs">M</p>
                          <p>{r.mVal ? "✔" : "-"}</p>
                      </div>
                      <div>
                          <p className="text-gray-400 text-xs">P</p>
                          <p>{r.pVal ? "✔" : "-"}</p>
                      </div>
                    </div>
                    <div>
                      <p className="text-gray-400 text-xs">Remarks</p>
                      <p>{r.remarks}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* </div> */}

            <div className='flex flex-row mt-2 mb-2'>
              <input 
                  type="checkbox" 
                  className="mr-2 cursor-pointer"
                  checked={addlDetails} 
                  onChange={() => setAddlDetails(!addlDetails)} 
              />
              <span className="text-xs lg:text-sm text-gray-100">Input Additional Details</span>
            </div>                   
            { addlDetails && (
                <div className='flex flex-col border border-blue-300 p-2'>
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">Person Think5Whys Code:</label>
                    <input
                        className="w-40 text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={userCode}
                        onChange={(e) => setUserCode(e.target.value)}
                    />
                    </div>
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">Master WBS Code:</label>
                    <input
                        className="w-40 text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={MWBSCode}
                        onChange={(e) => setMWBSCode(e.target.value)}
                    />
                    </div>
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">WBS Group / Category:</label>
                    <input
                        className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={WBSGroup}
                        onChange={(e) => setWBSGroup(e.target.value)}
                    />
                    </div>
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">Project:</label>
                    <input
                        className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={wbsProject}
                        onChange={(e) => setWBSProject(e.target.value)}
                    />
                    </div>
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">Program:</label>
                    <input
                        className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={wbsProgram}
                        onChange={(e) => setWBSProgram(e.target.value)}
                    />
                    </div>  
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">Entity / Organisation:</label>
                    <input
                        className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={entityName}
                        onChange={(e) => setEntityName(e.target.value)}
                    />
                    </div>                              
                    <div className="flex flex-col mb-2">
                    <label className="text-white text-xs lg:text-sm font-medium mb-2">Department:</label>
                    <input
                        className="w-full text-black p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        type="text"
                        value={wbsDepartment}
                        onChange={(e) => setWBSDepartment(e.target.value)}
                    />
                    </div>                                                                
                </div>
            )}
                                    
            <div className="flex flex-col">
                <label className="text-yellow-200 text-xs lg:text-sm font-medium mb-2">Input Final Remarks:</label>
                {showMicrophoneAlert ? (
                    <SpeechInputComponent
                    label="for most likely"
                    name="mDetails"
                    value={mDetails}
                    onChange={handleChange}
                    placeholder="Click Mic and Speak or Talk for Voice Input..."
                    maxLength="2000"
                    />
                ) : (                            
                    <textarea
                    className="w-full p-3 border border-gray-300 rounded-lg shadow-sm mt-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    style={{width: '100%', height:'150px'}}
                    />
                )}
                {isCheckedAISupport && mDetails !== "" && (
                    <div className="mb-1">
                    <AILightComponent
                        param1={"PTM 3P: Most Likely Estimation"}
                        param2={mDetails}
                    />
                    </div>
                    )}
            </div>  
            <div className='flex flex-row mt-2'>
                <input 
                    type="checkbox" 
                    className="mr-2 cursor-pointer"
                    checked={emethod} 
                    onChange={() => setEmethod(!emethod)} 
                />
                <span className="text-xs lg:text-sm text-gray-100">PERT Estimate (Weighted)</span>
            </div>                  
            <div className="flex justify-start mt-6 space-x-2">
                <button
                    className="px-3 text-xs lg:text-sm lg:w-40 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-500 transition"
                    onClick={() => {
                    generatePERTData();
                    setShowPERTTable(true);
                    }}
                    disabled={microWBS.length === 0} 
                >
                    Show PERT Table
                </button>
                <button
                    className="px-3 text-xs lg:text-sm lg:w-40 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-500 transition"
                    onClick={() => {
                    generateCriticalPath();
                    }}
                    disabled={microWBS.length === 0} 
                >
                    Show Critical Path
                </button>
                <button
                    className="px-3 text-xs lg:text-sm lg:w-40 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-500 transition"
                    onClick={() => {
                    generatePERTChart();
                    }}
                    disabled={microWBS.length === 0} 
                >
                    Show PERT Diagram
                </button>              
        </div>
        { showAd && (
            <div
                className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
                onClick={() => window.open("https://www.think5whys.com", "_blank")}
            >
            <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
                <img
                src={adimage2}
                alt="Ad"
                className="w-full h-full object-cover"
                />
            </div>

            <div className="flex flex-col text-left">
                <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
                <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
                <p className="text-sm mt-1">Click to see more!</p>
            </div>
            </div> 
        )} 
        {showPERTCard && pertData.length > 0 && (
            <div className="bg-gray-800 p-3 rounded-lg border border-purple-400 mt-4">
            <h2 className="text-yellow-200 text-sm lg:text-lg mb-3">PERT Table</h2>

            <div className="flex flex-col space-y-2">
                {pertData.map((r, i) => (
                <div key={i} className="bg-gray-700 p-3 rounded-lg">
                    <div className="grid grid-cols-2 gap-2 mb-2">
                    <p className="text-gray-400 text-xs">Node</p>
                    <p className="text-white">{r.node}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-2">
                    <p className="text-gray-400 text-xs">Activity / Task</p>
                    <p className="text-white">{r.task}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-2">
                    <p className="text-gray-400 text-xs">Predecessor(s)</p>
                    <p className="text-white">{r.predecessor.join(", ") || "-"}</p>
                    </div>
                    <div className="grid grid-cols-3 gap-2 mb-2">
                    <div>
                        <p className="text-gray-400 text-xs">O</p>
                        <p className="text-white">{r.oVal}</p>
                    </div>
                    <div>
                        <p className="text-gray-400 text-xs">M</p>
                        <p className="text-white">{r.mVal}</p>
                    </div>
                    <div>
                        <p className="text-gray-400 text-xs">P</p>
                        <p className="text-white">{r.pVal}</p>
                    </div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-2">
                    <p className="text-gray-400 text-xs">Expected Value (EV)</p>
                    <p className="text-white">{r.ev}</p>
                    </div>
                    <div className="grid grid-cols-2 gap-2 mb-2">
                    <p className="text-gray-400 text-xs">Cost</p>
                    <p className="text-white">{r.cost}</p>
                    </div>
                </div>
                ))}
            </div>
            </div>
        )}                  
        {showPERTTable && pertData.length > 0 && (
            <div className="bg-gray-800 p-3 rounded-lg border border-purple-400 mt-4 overflow-x-auto">
            <h2 className="text-yellow-200 text-sm lg:text-lg mb-3">PERT Table</h2>

            <table className="min-w-full text-sm text-white border-collapse">
                <thead>
                <tr className="bg-gray-700">
                    <th className="px-3 py-2 border border-gray-600">Node</th>
                    <th className="px-3 py-2 border border-gray-600">Activity / Task</th>
                    <th className="px-3 py-2 border border-gray-600">Predecessor(s)</th>
                    <th className="px-3 py-2 border border-gray-600">O</th>
                    <th className="px-3 py-2 border border-gray-600">M</th>
                    <th className="px-3 py-2 border border-gray-600">P</th>
                    <th className="px-3 py-2 border border-gray-600">EV</th>
                    <th className="px-3 py-2 border border-gray-600">Cost</th>
                </tr>
                </thead>

                <tbody>
                {pertData.map((r, i) => (
                    <tr key={i} className="bg-gray-700 even:bg-gray-600">
                    <td className="px-3 py-2 border border-gray-600">{r.node}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.task}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.predecessor.join(", ") || "-"}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.oVal}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.mVal}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.pVal}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.ev}</td>
                    <td className="px-3 py-2 border border-gray-600">{r.cost}</td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>
        )}   
        {showCriticalPath && criticalPath && criticalPath.length > 0 && (
            <div className="bg-gray-800 p-3 rounded-lg border border-purple-400 mt-4">
            <h2 className="text-yellow-200 text-sm lg:text-lg mb-3">Critical Path</h2>
            <p className="text-white mb-3">
                {criticalPath.map((node) => node.task || node).join(" → ")}
            </p>
            <div className="flex flex-col space-y-2">
                {criticalPath.map((node, i) => (
                <div
                    key={i}
                    className="bg-gray-700 p-3 rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center"
                >
                    <div className="mb-2 md:mb-0">
                    <p className="text-gray-400 text-xs">Node</p>
                    <p className="text-white font-semibold">{node.node || i + 1}</p>
                    </div>

                    <div className="mb-2 md:mb-0">
                    <p className="text-gray-400 text-xs">Task</p>
                    <p className="text-white">{node.task || "-"}</p>
                    </div>

                    <div className="mb-2 md:mb-0">
                    <p className="text-gray-400 text-xs">Predecessor(s)</p>
                    <p className="text-white">
                        {Array.isArray(node.predecessor) && node.predecessor.length > 0
                        ? node.predecessor.join(", ")
                        : "-"}
                    </p>
                    </div>

                    <div>
                    <p className="text-gray-400 text-xs">Duration (EV)</p>
                    <p className="text-white">{node.ev ?? "-"}</p>
                    </div>
                </div>
                ))}
            </div>
            </div>
        )}     
        {showPERTChart && PERTChartNodes.length > 0 && (
            <div className="bg-gray-800 p-3 rounded-lg border border-purple-400 mt-4 overflow-auto">
                <h2 className="text-yellow-200 text-sm lg:text-lg mb-3">PERT Chart</h2>
                <svg width="1000" height="600" className="border border-gray-600"> 
                    {PERTChartEdges.map((edge, i) => (
                        <line
                            key={i}
                            x1={edge.from.x + 60} y1={edge.from.y + 25} // adjust for node width/height
                            x2={edge.to.x + 60} y2={edge.to.y + 25}
                            stroke="#fff"
                            strokeWidth="2"
                            markerEnd="url(#arrowhead)"
                        />
                    ))}

                    <defs>
                    <marker
                        id="arrowhead"
                        markerWidth="10"
                        markerHeight="7"
                        refX="10"
                        refY="3.5"
                        orient="auto"
                    >
                        <polygon points="0 0, 10 3.5, 0 7" fill="#fff" />
                    </marker>
                    </defs>

                    {PERTChartNodes.map((node, i) => (
                        <g key={i}>
                            <rect
                            x={node.x} y={node.y}
                            width="120" height="50"
                            fill="#4f46e5"
                            stroke="#fff"
                            strokeWidth="2"
                            rx="8"
                            />
                            <text
                            x={node.x + 60} y={node.y + 20}
                            textAnchor="middle"
                            fill="#fff"
                            fontSize="12"
                            fontWeight="bold"
                            >
                            {node.task}
                            </text>
                            <text
                            x={node.x + 60} y={node.y + 35}
                            textAnchor="middle"
                            fill="#fff"
                            fontSize="10"
                            >
                            EV: {node.ev}
                            </text>
                        </g>
                    ))}
                </svg>
            </div>
        )}  
        <div className="flex flex-row mt-4">
            <button
                className="py-2 bg-purple-700 text-white rounded-lg shadow hover:bg-purple-600 transition"
                disabled={true}
                onClick={saveWBS}
                >
                Save to Database
            </button>
            <button
                className="py-2 bg-purple-700 text-white rounded-lg shadow hover:bg-purple-600 transition"
                disabled={false}
                onClick={downloadPDF}
                >
                Download as PDF
            </button>                  
        </div>      
      </div>
    </div>
    <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>    
  </div>
  );
};


export default WBSForm;
